import Breadcrumb from "components/shared/breadcrumb";
import Loading from "components/shared/loading";
import Pagination from "components/shared/pagination";
import { productFormId, productRoute, smallCropSize } from "constants/config";
import InitializeContext from "context/initialize-context";
import UseFetch from "hooks/useFetch";
import { useContext, useEffect, useMemo, useState } from "react";
import { Link, createSearchParams, useSearchParams } from "react-router-dom";
import { getProductImage, toMoneyFormat } from "utils";
import Searchbox from "./searchbox";

const AddProduct = () => {
    const [searchParams] = useSearchParams();
    const enums = useContext(InitializeContext);

    let formIdParam = searchParams.get("form_id")
    formIdParam = formIdParam && !isNaN(formIdParam) ? parseInt(formIdParam) : productFormId;

    const [fetchUrl, setFetchUrl] = useState(null);
    const { isLoading, data, error, mutate } = UseFetch(fetchUrl);

    useEffect(() => {
        const serviceParams = createSearchParams(searchParams);
        serviceParams.set("form_id", formIdParam);

        setFetchUrl(`/api/search/search?${serviceParams.toString()}`);
    }, [searchParams])

    const intendedForm = useMemo(() => {
        const output = enums.data.forms.find(form => form.id === formIdParam);
        return output || {};
        // eslint-disable-next-line
    }, [searchParams])

    return (
        <div className="m-container">
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-5 options-bar">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">افزودن محصول</h1>
                    <Breadcrumb
                        data={[
                            { title: "مدیریت فروشگاه" },
                            { title: "افزودن محصول", link: "/content/add-product" }
                        ]}
                    />
                </div>

                <div className="flex">
                    <button
                        className="w-10 h-10 tp-22 text-[#424e79] dark:text-white rounded-md fit-center"
                        title="بروزرسانی"
                        onClick={mutate}
                    >
                        <i className="fa-regular fa-arrows-retweet"></i>
                    </button>
                </div>
            </div>

            <div className="wrap-box tp-22">
                <Searchbox />

                {
                    !isLoading ? (
                        !error ? (
                            <>
                                <div className="page-transition">
                                    <div className="table-c1 mt-10 mb-4">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th className="w-24"></th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {
                                                    data.data?.length > 0 ? (
                                                        data.data.map(product => {
                                                            let image = product.fields[intendedForm.setting?.image] || null;
                                                            if (image)
                                                                image = image.split(";")[0];

                                                            const title = product.fields[intendedForm.setting?.title];
                                                            const baseUrl = intendedForm.setting?.url || productRoute;

                                                            return (
                                                                <tr key={`product-${product.id}`}>
                                                                    <td className="desc-col">
                                                                        <div className="flex items-center p-2">
                                                                            <img
                                                                                src={getProductImage(image, smallCropSize)}
                                                                                className="min-w-11 w-11 h-11 rounded-sm object-cover ml-4"
                                                                                width={360}
                                                                                height={360}
                                                                            />

                                                                            <a
                                                                                href={`${baseUrl}${product.id}`}
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                                className="text-blue-700 dark:text-blue-300 ml-3"
                                                                            >
                                                                                <i className="fa-regular fa-share-from-square"></i>
                                                                            </a>

                                                                            <div className="content noP">
                                                                                <p className="tp-25">{title}</p>
                                                                                <h6 className="tp-26">قیمت: {toMoneyFormat(product.module_fields.price.price)} تومان</h6>
                                                                            </div>
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        <Link
                                                                            to={`/panel/duplicate/${product.group_id}?form_id=${product.form_id}`}
                                                                            className="bg-primary-100 w-full text-white text-xs rounded-md py-2 block text-center transition-colors hover:bg-primary-200"
                                                                        >
                                                                            افزودن
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={3}>
                                                                <p className="global-error">موردی برای نمایش وجود ندارد</p>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="flex justify-between items-center">
                                    <span className="text-[#1d212f] dark:text-[#bdbdca] text-sm font-medium">
                                        {data.count} مورد - {Math.ceil(data.count / (searchParams.get("limit") || 10))} صفحه
                                    </span>

                                    {
                                        !!data.data?.length && (
                                            <Pagination
                                                count={data.count}
                                                limit={parseInt(searchParams.get("limit"))}
                                                offset={parseInt(searchParams.get("offset"))}
                                            />
                                        )
                                    }
                                </div>
                            </>
                        ) : <p className="global-error">خطای سیستم !</p>
                    ) : <div className="fit-center"><Loading className="loading-c5" /></div>
                }
            </div>
        </div>
    )
}

export default AddProduct;